
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"); //匹配字段
  if (arr = document.cookie.match(reg)) {
    return decodeURIComponent(arr[2]);
  } else {
    return null;
  }
}

/**
 * 获取枚举描述
 * @param {*} value 值
 * @param {*} list 枚举列表
 * @param {*} id 值的key
 * @param {*} name 描述的key
 */
export function getSelectDesc (value, list, id = 'id', name = 'name') {
  let ind = list.findIndex((item) => item[id] === value)
  if (ind > -1) {
    return list[ind][name]
  } else {
    return ''
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js